import { Flex, Text } from '@mantine/core'

import { type CoreBookingProduct } from '@flecto/types'
import { AvatarProduct } from '@flecto/ui'

export type CellNameProps = {
  bookingProduct?: CoreBookingProduct
}

export function CellName({ bookingProduct }: CellNameProps) {
  return (
    <Flex align='center' gap='sm'>
      <AvatarProduct product={bookingProduct?.product} />
      <Text fw={500} truncate>
        {bookingProduct?.product?.title}
      </Text>
    </Flex>
  )
}
